import * as tslib_1 from "tslib";
import { BitmapFilter } from "./BitmapFilter";
var DropShadowFilter = (function (_super) {
    tslib_1.__extends(DropShadowFilter, _super);
    function DropShadowFilter(distance, angle, color, alpha, blurX, blurY, strength, quality, inner, knockout, hideObject) {
        if (color === void 0) { color = 0xffffff; }
        if (alpha === void 0) { alpha = 1; }
        if (blurX === void 0) { blurX = 1; }
        if (blurY === void 0) { blurY = 1; }
        if (strength === void 0) { strength = 1; }
        if (quality === void 0) { quality = 1; }
        if (inner === void 0) { inner = false; }
        if (knockout === void 0) { knockout = false; }
        if (hideObject === void 0) { hideObject = false; }
        return _super.call(this) || this;
    }
    DropShadowFilter.prototype.clone = function () {
        console.log("clone not implemented yet in flash/DropShadowFilter");
        return null;
    };
    return DropShadowFilter;
}(BitmapFilter));
export { DropShadowFilter };
